import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import Graphics from './../utils/Graphics';
import {GenericButton} from "./../../manifest/util/Styles";

import * as Tone from 'tone'

const OCTAVE_WIDTH_PCT = 13.5;
const HORIZONTAL_MARGIN_PCT = 2.75;
const OCTAVES_COUNT = 7

const SEGMENT_HEIGHT_PCT = 15;
const VERTICAL_MARGIN_PCT = 5;
const SEGMENT_COUNT = 6;

const PlayField = styled.div`
    width: 100%;
    height: 100%;
`;

export class PlayScreen extends Component {

    static propTypes = {}

    state = {};

    componentDidMount() {
    }

    make_some_noise = () => {
        const vol1 = new Tone.Volume(-5).toDestination();
        const vol2 = new Tone.Volume(-8).toDestination();
        const vol3 = new Tone.Volume(-13).toDestination();
        const vol4 = new Tone.Volume(-21).toDestination();
        const vol5 = new Tone.Volume(-34).toDestination();
        const vol6 = new Tone.Volume(-55).toDestination();
        const vol7 = new Tone.Volume(-89).toDestination();
        const osc1 = new Tone.Oscillator(440, "sine").connect(vol1);
        const osc2 = new Tone.Oscillator(440 * 2, "sine").connect(vol2);
        const osc3 = new Tone.Oscillator(440 * 3, "sine").connect(vol3);
        const osc4 = new Tone.Oscillator(440 * 4, "sine").connect(vol4);
        const osc5 = new Tone.Oscillator(440 * 5, "sine").connect(vol5);
        const osc6 = new Tone.Oscillator(440 * 6, "sine").connect(vol6);
        const osc7 = new Tone.Oscillator(440 * 7, "sine").connect(vol7);
        osc1.start();
        osc2.start();
        osc3.start();
        osc4.start();
        osc5.start();
        osc6.start();
        osc7.start();
        setTimeout(() => {
            osc1.stop();
            osc2.stop();
            osc3.stop();
            osc4.stop();
            osc5.stop();
            osc6.stop();
            osc7.stop();
        }, 500);
    }

    render() {
        let horizontal_axes = [];
        for (let horizontals = 0; horizontals <= SEGMENT_COUNT; horizontals++) {
            const percent = VERTICAL_MARGIN_PCT + horizontals * SEGMENT_HEIGHT_PCT;
            horizontal_axes.push(Graphics.horizontal_axis(`${percent}%`, "#888888", "0.10rem"))
        }
        let vertical_axes = [];
        for (let verticals = 0; verticals <= OCTAVES_COUNT; verticals++) {
            const percent = HORIZONTAL_MARGIN_PCT + verticals * OCTAVE_WIDTH_PCT;
            vertical_axes.push(Graphics.vertical_axis(`${percent}%`, "#888888", "0.10rem"))
        }
        return <PlayField src={'/freq?screen=play'}>
            <GenericButton onClick={e => this.make_some_noise()}>make some noisea</GenericButton>
            {vertical_axes}
            {horizontal_axes}
        </PlayField>
    }
}

export default PlayScreen;
